import React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";

interface IFlexiTableProps{
    data: any[]
}

export const FlexiTable = (props: IFlexiTableProps) => {
    const total = () : number => {
        let sum = 0;
        props.data?.forEach(d => sum += d.availableValue.Amount);
        return sum;
    }

    return (
        <>
            { props.data?.length !== 0 &&
                <>
                <h3>Flexible drawdown</h3>
                        <div className="panel-subtle panel-scrollable pt-10 pb-10 mb-50">
                        <div>
                            <table className="table-subtle table-first-last-cell-padding-reset">
                                <thead>
                                    <tr>
                                        <th>Arrangement ID</th>
                                        <th>Disqualifying Pension Credit</th>
                                        <th>Inherited drawdown</th>
                                        <th>Taxable</th>
                                        <th>Converted from capped</th>
                                        <th>Date converted</th>
                                        <th>Date opened</th>
                                        <th className="cell-right">Date closed</th>
                                        <th className="cell-right">Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { props.data.map((row, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{row.arrangementis}</td>
                                                <td>{row.credit}</td>
                                                <td>{row.drawdown}</td>
                                                <td>{row.taxable}</td>
                                                <td>{row.convert}</td>
                                                <td>{row.dateconverted}</td>
                                                <td>{row.date}</td>
                                                <td className="cell-right">{row.dateclose}</td>
                                                <td className="cell-right">
                                                    {MoneyDisplayHelper.FromatMoneyDisplay(
                                                        row.availableValue.Amount,
                                                        CurrencyCode.GBP,
                                                        true,
                                                        2
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={8} className="cell-total">Total</td>
                                        <td className="cell-value cell-right">
                                            {MoneyDisplayHelper.FromatMoneyDisplay(
                                                total(),
                                                CurrencyCode.GBP,
                                                true,
                                                2
                                            )}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </>
            }
        </>
    );

}
